import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getCustomer,
  getMaterial,
  getUser,
  postRtv,
  getParam,
  postFile,
  updatePostRtv,
  getClient,
  getMaterialOld
} from "./withrtvAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  rtv: [],
  dataCustomer: [],
  dataClient: [],
  dataMaterial: [],
  dataMaterialOld: [],
  reasonParam: [],
  uploadFileId: null,
  updateRtv: null,
  user: null,
};

export const fetchAll = createAsyncThunk(
  "withrtv/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);

export const createRtv = createAsyncThunk(
  "withrtv/createRtv",
  async (payload) => {
    const response = await postRtv(payload);
    return response;
  }
);

export const fetchCustomer = createAsyncThunk(
  "withrtv/fetchCustomer",
  async (payload) => {
    const response = await getCustomer(payload);
    return response.data;
  }
);

export const fetchClient = createAsyncThunk(
  "withrtv/fetchClient",
  async (payload) => {
    const response = await getClient(payload);
    return response.data;
  }
);

export const fetchMaterial = createAsyncThunk(
  "withrtv/fetchMaterial",
  async (payload) => {
    const response = await getMaterial(payload);
    return response.data;
  }
);

export const fetchUser = createAsyncThunk(
  "withrtv/fetchUser",
  async (payload) => {
    const response = await getUser(payload);
    return response.data;
  }
);

export const fetchReasonParam = createAsyncThunk(
  "withrtv/fetchReasonParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const updateReasonParam = createAsyncThunk(
  "withrtv/updateReasonParam",
  async (payload) => {
    return payload;
  }
);

export const uploadFile = createAsyncThunk(
  "withrtv/uploadFile",
  async ({ file }) => {
    const response = await postFile(file);
    return response.data;
  }
);

export const editRtv = createAsyncThunk(
  "withrtv/rtvEdit",
  async ({ params, id }) => {
    const response = await updatePostRtv(params, id);
    console.log(params, id, "slice");
    return response;
  }
);

export const fetchMaterialOld = createAsyncThunk(
  "withrtv/fetchMaterialOld",
  async (payload) => {
    const response = await getMaterialOld(payload);
    return response.data;
  }
);

export const withrtvSlice = createSlice({
  name: "withrtv",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setRtv: (state, action) => {
      state.rtv = action.payload;
    },
    setReason: (state, action) => {
      state.reason = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
      })
      .addCase(fetchCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.dataCustomer = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchClient.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchClient.fulfilled, (state, action) => {
        state.loading = false;
        state.dataClient = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.dataMaterial = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createRtv.pending, (state) => {
        state.loading = true;
      })
      .addCase(createRtv.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createRtv.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateReasonParam.fulfilled, (state, action) => {
        state.reasonParam = action.payload;
      })
      .addCase(fetchReasonParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReasonParam.fulfilled, (state, action) => {
        state.loading = false;
        state.reasonParam = action.payload.data;
      })
      .addCase(uploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadFileId = action.payload.data;
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(editRtv.pending, (state) => {
        state.loading = true;
      })
      .addCase(editRtv.fulfilled, (state, action) => {
        state.loading = false;
        state.updateRtv = action.payload;
      })
      .addCase(fetchMaterialOld.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMaterialOld.fulfilled, (state, action) => {
        state.loading = false;
        state.dataMaterialOld = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
  },
});

export const { resetData, setSelected, setRtv, setUser } = withrtvSlice.actions;

export const selectData = (state) => state.withrtv.data;
export const selectDataMaterial = (state) => state.withrtv.dataMaterial;
export const selectDataMaterialOld = (state) => state.withrtv.dataMaterialOld;
export const selectDataCustomer = (state) => state.withrtv.dataCustomer;
export const selectDataClient = (state) => state.withrtv.dataClient;
export const selectLoading = (state) => state.withrtv.loading;
export const selectError = (state) => state.withrtv.error;
export const selectPageNo = (state) => state.withrtv.pageNo;
export const selectPageSize = (state) => state.withrtv.pageSize;
export const selectTotalRecord = (state) => state.withrtv.totalRecord;
export const selectSelected = (state) => state.withrtv.selected;
export const selectRtv = (state) => state.withrtv.rtv;
export const selectReasonParam = (state) => state.withrtv.reasonParam;
export const selectUploadFileId = (state) => state.withrtv.uploadFileId;
export const selectUpdateRtv = (state) => state.withrtv.updateRtv;
export const selectUser = (state) => state.withrtv.user;

export default withrtvSlice.reducer;
